import React, {useEffect, useState} from "react";

import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "../../style/datePicker.css"
import {Input, Typography} from "@material-tailwind/react";

const FromToDateField = ({className, fromDate, setFromDate, toDate, setToDate, label}) => {

  const [fromCurDate, setFromCurDate] = useState(fromDate);
  const [toCurDate, setToCurDate] = useState(toDate);


  useEffect(() => {
    if (fromCurDate.month !== undefined) {
      const selectedDate = fromCurDate.year + "-" + fromCurDate.month.toString().padStart(2, '0') + "-" + fromCurDate.day.toString().padStart(2, '0')
      setFromDate(selectedDate)
    }
  }, [fromCurDate]);

  useEffect(() => {
    if (toCurDate.month !== undefined) {
      const selectedDate = toCurDate.year + "-" + toCurDate.month.toString().padStart(2, '0') + "-" + toCurDate.day.toString().padStart(2, '0')
      setToDate(selectedDate)
    }
  }, [toCurDate]);

  return (
    <div className="flex flex-col gap-x-2 w-full mb-4 md:flex-row">
      <div className="flex flex-row w-full mb-4">
        <Typography className="w-1/2 mt-2 md:w-1/3">
          {`${label} از:`}
        </Typography>
        <div style={{direction: "rtl"}} className="w-1/2 md:w-2/3 -mt-2">
          <DatePicker
            calendar={persian}
            className="rmdp-calendar"
            render={<Input
              // label={label}
              variant="standard"
              className="w-full max-w-[150px]"
            />}
            value={fromCurDate || new Date()}
            onChange={setFromCurDate}
            locale={persian_fa}
            calendarPosition="bottom-center md:bottom-right"
          />
        </div>
      </div>

      <div className=" flex flex-row w-full">
        <Typography className="w-1/2 mt-2 md:w-1/3">
          تا:
        </Typography>
        <div style={{direction: "rtl"}} className="w-1/2 md:w-2/3 -mt-2">
          <DatePicker
            calendar={persian}
            className="rmdp-calendar"
            render={<Input
              // label={label}
              variant="standard"
              className="w-full  max-w-[150px]"
            />}
            value={toCurDate || new Date()}
            onChange={setToCurDate}
            locale={persian_fa}
            calendarPosition="bottom-center md:bottom-right"
          />
        </div>
      </div>
    </div>
  )
    ;
};

export default FromToDateField;
